export const trackSourceOptions = [
  { label: 'All Track Sources', value: '' },
  { label: 'regular', value: 'regular' },
  { label: 'screen', value: 'screen' },
  { label: 'audioplaylist', value: 'audioplaylist' },
  { label: 'videoplaylist', value: 'videoplaylist' },
];
export const trackTypeOptions = [
  { label: 'All Track Types', value: '' },
  { label: 'audio', value: 'audio' },
  { label: 'video', value: 'video' },
];

export const DEFAULT_TILES_IN_VIEW = { MWEB: 4, DESKTOP: 9 };
